import { useEffect, useState } from 'react';
import { api, ApiError } from '../../api/client';
import { Banner } from '../States';

/**
 * Configurações da operação de pedidos: o WhatsApp que recebe os pedidos e o
 * token que faz o link do anúncio abrir no aplicativo do Youpin.
 *
 * Fica recolhida atrás de um botão: mexe-se nisso de vez em quando, e no meio
 * da fila ela só empurrava os pedidos para baixo.
 */
export function ConfigPedidos({ whatsappAtual, onSalvo }: { whatsappAtual: string; onSalvo: () => void }) {
  const [whats, setWhats] = useState(whatsappAtual);
  const [token, setToken] = useState('');
  const [exemplo, setExemplo] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);

  useEffect(() => setWhats(whatsappAtual), [whatsappAtual]);

  useEffect(() => {
    void api
      .adminMarketplaceLink()
      .then((r) => {
        setToken(r.token);
        setExemplo(r.exemplo);
      })
      .catch(() => {
        // Sem o token o painel continua útil: só os links de compra deixam de
        // abrir no aplicativo.
      });
  }, []);

  async function salvarWhats() {
    setOcupado(true);
    setErro(null);
    setOk(null);
    try {
      await api.adminSalvarWhatsapp(whats);
      setOk('WhatsApp do atendimento salvo.');
      onSalvo();
    } catch (e) {
      setErro(e instanceof ApiError ? e.message : 'Não consegui salvar o número.');
    } finally {
      setOcupado(false);
    }
  }

  async function salvarToken() {
    setOcupado(true);
    setErro(null);
    setOk(null);
    try {
      const r = await api.adminSalvarMarketplaceLink(token);
      setToken(r.token);
      setExemplo(r.exemplo);
      setOk('Link do marketplace atualizado. Os pedidos abertos já abrem no aplicativo.');
    } catch (e) {
      setErro(e instanceof ApiError ? e.message : 'Não consegui salvar o link.');
    } finally {
      setOcupado(false);
    }
  }

  return (
    <section className="gp-config">
      {erro && <Banner kind="error">{erro}</Banner>}
      {ok && <Banner kind="ok">{ok}</Banner>}

      <label className="field" htmlFor="gp-whats">
        <span>WhatsApp que recebe os pedidos</span>
        <div className="actions-row">
          <input
            id="gp-whats"
            className="input"
            value={whats}
            onChange={(e) => setWhats(e.target.value)}
            placeholder="5511999999999"
            inputMode="numeric"
          />
          <button className="btn primary" onClick={() => void salvarWhats()} disabled={ocupado}>
            Salvar
          </button>
        </div>
        <small>DDI + DDD + número, só dígitos. É para onde o fechamento da sacola manda o cliente.</small>
      </label>

      <label className="field" htmlFor="gp-token">
        <span>Link de compra no Youpin (externalToken)</span>
        <div className="actions-row">
          <input
            id="gp-token"
            className="input"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="cole um link do app, ou só o externalToken"
          />
          <button className="btn primary" onClick={() => void salvarToken()} disabled={ocupado || !token.trim()}>
            Salvar
          </button>
        </div>
        <small>
          O botão de compra de cada item leva à peça exata no aplicativo. O token vence de tempos em tempos: quando os
          links pararem de abrir, copie um link novo do app (goodsInfo.html?id=…&amp;externalToken=…) e cole inteiro
          aqui.
        </small>
        {exemplo && (
          <small className="dim break">
            Exemplo com o token atual: <code>{exemplo}</code>
          </small>
        )}
      </label>
    </section>
  );
}
